module.exports = __webpack_public_path__ + "img/model_18_zh.3607773d.jpg";